import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import { type FC, useMemo } from "react";

const iconColors = ["#49bbcb", "#5e93d1", "#72c083", "#987ad9", "#9b8c9d", "#b76491", "#de7a31", "#f46565"];

function hashCode(s: string) {
    return Math.abs(
        s.split("").reduce(function (a, b) {
            a = (a << 5) - a + b.charCodeAt(0);
            return a & a;
        }, 0),
    );
}

type MemberIconProps = {
    name: string;
};
export const MemberIcon: FC<PropsWithClassName & MemberIconProps> = ({ name, className }) => {
    const orgInitials = useMemo(() => {
        const initials = name
            .split(" ")
            .filter((w) => !!w && w.length > 1)
            .map((n) => n[0])
            .join("");
        return initials.substring(0, 2).toUpperCase();
    }, [name]);

    const backgroundColor = iconColors[hashCode(name) % iconColors.length];

    return (
        <div
            className={cn("inline-flex h-8 w-8 select-none items-center justify-center rounded-full", className)}
            style={{ backgroundColor }}
        >
            <span className="inline-block w-6 text-center text-xs leading-6 text-white">{orgInitials}</span>
        </div>
    );
};
